import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const KEY = "tenant_brand";
const TenantBrandContext = createContext({ brand: null, loading: true, setBrand: () => {} });

const readStored = () => {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
};

export function TenantBrandProvider({ children }) {
  const [state, setState] = useState({ brand: readStored(), loading: true });

  const setBrand = useCallback((brand) => {
    if (brand) sessionStorage.setItem(KEY, JSON.stringify(brand));
    else sessionStorage.removeItem(KEY);
    setState({ brand, loading: false });
  }, []);

  useEffect(() => {
    api
      .get("/public/tenant-by-host", { params: { host: window.location.hostname } })
      .then((r) => setState((s) => ({ brand: r.data.tenant || s.brand, loading: false })))
      .catch(() => setState((s) => ({ ...s, loading: false })));
  }, []);

  return <TenantBrandContext.Provider value={{ ...state, setBrand }}>{children}</TenantBrandContext.Provider>;
}

export const useTenantBrand = () => useContext(TenantBrandContext);
